import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = { class: "ion-margin-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_datetime_button = _resolveComponent("ion-datetime-button")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        slot: "icon-only",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { style: {"padding-left":"0"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.formattedSession.name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.loadingData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "3"
                              }, {
                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                  _createTextVNode("On")
                                ])),
                                _: 1,
                                __: [8]
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "9"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_datetime_button, {
                                    datetime: `${_ctx.formattedSession.id}_date`,
                                    style: {"font-size":"14px","justify-content":"left"}
                                  }, null, 8, ["datetime"]),
                                  _createVNode(_component_ion_modal, {
                                    class: "datetime-modal",
                                    "keep-contents-mounted": true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_datetime, {
                                        presentation: "date",
                                        id: `${_ctx.formattedSession.id}_date`,
                                        modelValue: _ctx.formattedSession.date,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formattedSession.date) = $event)),
                                        showDefaultButtons: true
                                      }, null, 8, ["id", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "3"
                              }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode("Venue")
                                ])),
                                _: 1,
                                __: [9]
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "9"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    mode: "ios",
                                    modelValue: _ctx.formattedSession.venue,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formattedSession.venue) = $event)),
                                    fill: "outline"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "3"
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createTextVNode("Class start")
                                ])),
                                _: 1,
                                __: [10]
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "9"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    mode: "ios",
                                    type: "time",
                                    modelValue: _ctx.formattedSession.startTime,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formattedSession.startTime) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "3"
                              }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode("Duration")
                                ])),
                                _: 1,
                                __: [11]
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "9"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    mode: "ios",
                                    type: "number",
                                    modelValue: _ctx.formattedSession.duration,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formattedSession.duration) = $event)),
                                    disabled: "",
                                    fill: "outline"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "3"
                              }, {
                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                  _createTextVNode("Class end")
                                ])),
                                _: 1,
                                __: [12]
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "9"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    mode: "ios",
                                    type: "time",
                                    modelValue: _ctx.displayEndTime,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.displayEndTime) = $event)),
                                    disabled: "",
                                    fill: "outline"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "3"
                              }, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode("Remarks")
                                ])),
                                _: 1,
                                __: [13]
                              }),
                              _createVNode(_component_ion_col, {
                                class: "ion-text-left",
                                size: "9"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    mode: "ios",
                                    modelValue: _ctx.formattedSession.remarks,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formattedSession.remarks) = $event)),
                                    fill: "outline"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _cache[14] || (_cache[14] = _createTextVNode(" I will")),
                          _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessionStatusMapping, (opt) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              lines: "none",
                              key: opt.value
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  slot: "start",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formattedSession.status) = $event)),
                                  name: opt.value,
                                  value: opt.value
                                }, null, 8, _hoisted_2), [
                                  [_vModelRadio, _ctx.formattedSession.status]
                                ]),
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, _toDisplayString(opt.radioOption), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.displayChoiceDescription), 1)
                        ]),
                        _: 1,
                        __: [14,15]
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    color: "success",
                    expand: "block",
                    onClick: _ctx.saveUpdatedSession
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" Save ")
                    ])),
                    _: 1,
                    __: [16]
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}